import { ResponseTransformer } from '@lemsar/api/transformers/response';
import { Injectable } from '@angular/core';
import { LemsarApiClient } from '@lemsar/api/client';
import { Observable } from 'rxjs/Observable';
import { BuildingType } from '@lemsar/common/domains/models/building-type';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    22/06/2018
 */
@Injectable()
export class BuildingTypeService {
    public constructor(private api: LemsarApiClient) {}

    public fetchAll(): Observable<BuildingType[]> {
        return this.api.get<any>('building-types').pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(BuildingType));
    }

    public fetchByType(type: string): Observable<BuildingType[]> {
        return this.api
            .get<any>('building-types?type=' + type)
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(BuildingType));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/services/building-type.service.ts